import * as React from 'react';

import { testAttribute } from 'utils/DataTestId';
import { MarkdownWrapper } from '../MarkdownWrapper/MarkdownWrapper';
import styles from './ErrorPage.module.scss';
import errorPageImage from 'images/503-image-lockup.svg';
import { Image } from 'components/Image/Image';

interface IErrorPageProps {
  title: string;
  blurb: string;
  hasImage?: boolean;
}

export const ErrorPage: React.FC<IErrorPageProps> = ({ title, blurb, hasImage = false }) => (
  <div className={styles.errorPage}>
    {hasImage && <Image className={styles.errorImage} src={errorPageImage} />}
    <section>
      <h1 data-testid={testAttribute(title)} className={styles.errorTitle}>
        {title}
      </h1>
      <MarkdownWrapper
        className={styles.errorBlurb}
        source={blurb}
        dataTestIdLinkAttr={`${testAttribute(title)}-link`}
      />
    </section>
  </div>
);
